module.exports = __webpack_public_path__ + "img/unicall-logo-sign.f8356446.svg";